import { render, staticRenderFns } from "./GroupUserAttributeList.vue?vue&type=template&id=3b82399f&"
import script from "./GroupUserAttributeList.vue?vue&type=script&lang=ts&"
export * from "./GroupUserAttributeList.vue?vue&type=script&lang=ts&"
import style0 from "./GroupUserAttributeList.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports